import { Construction } from 'lucide-react';

export const ComingSoonTab = ({ title, blurb }: { title: string; blurb: string }) => (
  <div className="p-10 flex items-center justify-center min-h-[60vh]">
    <div className="max-w-md text-center">
      <div className="w-16 h-16 mx-auto rounded-full bg-green01/10 border border-green01/40 flex items-center justify-center mb-4">
        <Construction size={28} className="text-green01" />
      </div>
      <h2 className="text-white text-2xl font-bold mb-2">{title}</h2>
      <p className="text-greyP2 text-sm leading-relaxed">{blurb}</p>
      <span className="inline-block mt-4 text-[10px] uppercase tracking-wider font-bold text-green01 px-2 py-1 rounded-full border border-green01/40 bg-green01/5">
        Coming soon
      </span>
    </div>
  </div>
);
